import { CouriersI } from '../interfaces/couriers.interface'
import { CouriersService } from '../services/couriers.service'
import { GetCallsParamsT, GetCallsResponseT } from '../types/calls.types'
import {
    CourierPayloadT,
    CouriersCreateCourierResponseT,
    CouriersGetListResponseT,
    CouriersGetVehicleTypesResponseT,
    CouriersUpdateCourierResponseT,
    CouriersDownloadCourierResponseT,
    VehicleTypePayload,
    CouriersDownloadCourierPayloadT,
    CouriersGetCourierResponseT,
    CourierCarPayloadT,
    CouriersGetCarsResponseT,
    CouriersGetCarResponseT,
    CourierCarCreatePayloadT,
    CouriersCloseDayResponseT,
    CouriersGetCarsStatusesT,
    CarChangeStatusPayload,
    CouriersGetParamsT,
    SchedulePayload,
    CouriersCreateCarResponseT,
    CouriersGetTypesResponseT,
} from '../types/couriers.types'

const couriersService = new CouriersService()

class CouriersRealisation implements CouriersI {
    getList(params: any): Promise<CouriersGetListResponseT> {
        return couriersService.getList(params)
    }

    getCourierTypes(): Promise<CouriersGetTypesResponseT> {
        return couriersService.getCourierTypes()
    }

    getCalls(params: GetCallsParamsT): Promise<GetCallsResponseT> {
        return couriersService.getCalls(params)
    }

    createCourier(courier_payload: FormData): Promise<CouriersCreateCourierResponseT> {
        return couriersService.createCourier(courier_payload)
    }

    createCategory(category_payload: VehicleTypePayload): Promise<void> {
        return couriersService.createCategory(category_payload)
    }

    createSchedule(schedule_payload: SchedulePayload): Promise<void> {
        return couriersService.createSchedule(schedule_payload)
    }

    createJira(): Promise<void> {
        return couriersService.createJira()
    }

    updateCourier(
        courier_id: number,
        courier_payload: CourierPayloadT
    ): Promise<CouriersUpdateCourierResponseT> {
        return couriersService.updateCourier(courier_id, courier_payload)
    }

    updateCategory(category_id: number, category_payload: VehicleTypePayload): Promise<void> {
        return couriersService.updateCategory(category_id, category_payload)
    }

    deleteCourier(courier_id: number): Promise<void> {
        return couriersService.deleteCourier(courier_id)
    }

    deleteCategory(category_id: number): Promise<void> {
        return couriersService.deleteCategory(category_id)
    }

    getVehicleTypes(page: number): Promise<CouriersGetVehicleTypesResponseT> {
        return couriersService.getVehicleTypes(page)
    }

    exportExcel(
        params: CouriersDownloadCourierPayloadT
    ): Promise<CouriersDownloadCourierResponseT> {
        return couriersService.exportExcel(params)
    }

    setCheckupStatus(courier_id: number): Promise<void> {
        return couriersService.setCheckupStatus(courier_id)
    }

    setActiveStatus(courier_id: number): Promise<void> {
        return couriersService.setActiveStatus(courier_id)
    }

    setArchiveStatus(courier_id: number): Promise<void> {
        return couriersService.setArchiveStatus(courier_id)
    }

    getCourier(courier_id: number): Promise<CouriersGetCourierResponseT> {
        return couriersService.getCourier(courier_id)
    }

    uploadDocument(courier_id: number, form_data: FormData): Promise<void> {
        return couriersService.uploadDocument(courier_id, form_data)
    }

    uploadCarDocument(car_id: number, form_data: FormData): Promise<void> {
        return couriersService.uploadCarDocument(car_id, form_data)
    }

    getCars(params: CouriersGetParamsT): Promise<CouriersGetCarsResponseT> {
        return couriersService.getCars(params)
    }

    getCar(car_id: number): Promise<CouriersGetCarResponseT> {
        return couriersService.getCar(car_id)
    }

    createCar(car_payload: CourierCarCreatePayloadT): Promise<CouriersCreateCarResponseT> {
        return couriersService.createCar(car_payload)
    }

    updateCar(car_id: number, car_payload: CourierCarPayloadT): Promise<void> {
        return couriersService.updateCar(car_id, car_payload)
    }

    deleteCar(car_id: number): Promise<void> {
        return couriersService.deleteCar(car_id)
    }

    getCarsStatuses(params: any): Promise<CouriersGetCarsStatusesT> {
        return couriersService.getCarsStatuses(params)
    }

    changeCarStatus(payload: CarChangeStatusPayload): Promise<void> {
        return couriersService.changeCarStatus(payload)
    }

    closeDay(courier_id: number, date: string | null): Promise<CouriersCloseDayResponseT> {
        return couriersService.closeDay(courier_id, date)
    }

    saveShortcoming(payload: FormData): Promise<void> {
        return couriersService.saveShortcoming(payload)
    }

    savePaymentTakes(payload: FormData): Promise<void> {
        return couriersService.savePaymentTakes(payload)
    }

    savePaymentDeliveries(payload: FormData): Promise<void> {
        return couriersService.savePaymentDeliveries(payload)
    }

    rejectCourier(courier_id: number): Promise<void> {
        return couriersService.rejectCourier(courier_id)
    }
}

export const couriers = new CouriersRealisation()
